import { FuseNavigationItem } from '@fuse/components/navigation';

export const amaNavigation: FuseNavigationItem = {
    id: 'ama',
    title: 'Ama',
    type: 'collapsable',
    iconFontSet: 'material-symbols-outlined',
    icon: 'description',
    children: [
        {
            id   : 'notes',
            title: 'notes',
            type : 'basic',
            iconFontSet: 'material-symbols-outlined',
            icon : 'other_admission',
            link : '/ama/note',
            meta : {
                permission: 'ama.note.access',
            },
        },
        {
            id   : 'my-notes',
            title: 'my-notes',
            type : 'basic',
            iconFontSet: 'material-symbols-outlined',
            icon : 'note',
            link : '/ama/my-notes',
            meta : {
                permission: 'ama.my-note.access',
            },
        },
        {
            id: 'tags',
            title: 'Tag',
            type: 'basic',
            iconFontSet: 'material-symbols-outlined',
            icon: 'sell',
            link: '/ama/tag',
            meta : {
                permission: 'ama.tag.access',
            },
        },
        {
            id   : 'topics',
            title: 'Topic',
            type : 'basic',
            iconFontSet: 'material-symbols-outlined',
            icon : 'location_on',
            link : '/ama/topic',
            meta : {
                permission: 'ama.topic.access',
            },
        },
    ],
};
